<template>
  <div>
    <c-row>
      <c-col col="12">
        <loader v-show="loading" />
        <c-card>
          <c-card-header>
            <strong>Stock Opname berdasar Kode Garansi</strong>
            <div class="card-header-actions">
              <button class="btn btn-success" @click="input = true">
                Tambah Garansi
              </button>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto; min-height: 350px">
            <div class="form-group">
              <product-name-selector @input="changeProduct" v-model="product" />
            </div>
            <div v-if="input">
              <div class="form-group">
                <label>Kode Garansi</label>
                <input type="text" class="form-control" v-model="warranty_code" />
              </div>
              <button class="btn btn-primary mr-2" @click="input = false">
                Batal
              </button>
              <button class="btn btn-success" @click="inputBaru">Simpan</button>
            </div>
            <table class="table table-bordered table-striped" v-else>
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Nama</th>
                  <th>Kode Garansi</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data" :key="k">
                  <td class="center">
                    <table-number-2 :paginate="paginate" :index="k" />
                  </td>
                  <td>
                    <span v-if="product">{{ product.name }}</span>
                  </td>
                  <td>{{ d.warranty }}</td>
                  <td align="center">
                    <a class="link link-danger" @click="remove(d)"> Hapus </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <div class="float-left">Total Data: {{ paginate.total }}</div>
            <paginator :paginator="paginate" @change="changePage" />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import Paginator from '../../components/Paginator.vue';
import ProductNameSelector from '../../components/ProductNameSelector.vue';
import TableNumber2 from '../../components/TableNumber2.vue';
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    Loader,
    ProductNameSelector,
    Paginator,
    TableNumber2
  },
  data () {
    return {
      loading: false,
      data: [],
      pid: '',
      paginate: {},
      product: {},
      input: false,
      warranty_code: ''
    };
  },
  created () {
    const query = this.$route.query;
    if (query.pid) {
      this.pid = query.pid;
      this.get(this.pid);
      this.loadData(1);
    }
  },
  methods: {
    get (code) {
      HTTPAUTH.get(`/api/v1/product/code/${code}`).then(res => {
        this.product = res.data.data;
      })
    },
    loadData (page) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/product/${this.pid}/items?size=10&page=${page}`).then(res => {
        this.data = res.data.data;
        this.paginate = res.data.paginate;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
      this.$router.push({ query: { pid: this.pid } }).catch(() => { })
    },
    changeProduct (p) {
      this.pid = p.code;
      this.get(p.code)
      this.loadData(1)
    },
    changePage (page) {
      this.loadData(page);
    },
    remove (data) {
      if (confirm(`Yakin akan menghapus produk dengan kode garansi ${data.warranty}?`)) {
        HTTPAUTH.put(`/api/v1/product/${data.id}/so`).then(() => {
          this.loadData(1)
        })
      }
    },
    inputBaru () {
      if (confirm(`Yakin akan menambahkan produk dengan kode garansi ${this.warranty_code}?`)) {
        HTTPAUTH.put(`/api/v1/product/${this.warranty_code}/so/add`).then(() => {
          this.loadData(1)
          this.input = false;
        }).catch(eres => {
          showErrorMessage(eres)
        })
      }
    }
  },
  watch: {
  }
};
</script>